<template>
  <v-layout wrap>
    <v-flex
      v-for="(sqItem, index) in sq5gResult.location"
      :key="index"
      class="custom-bg custom-border ma-3 px-4 pt-4"
      lg5
    >
      <p class="font-weight-bold">
        SQ Address: {{ setSqAddress(sqItem.sqAddress) }}
      </p>
      <p class="font-weight-bold">SQ ID: {{ setSqId }}</p>
      <v-list
        v-for="(
          item, subIndex
        ) in sqItem.mobileQualification.serviceSpecCharacteristics.filter(
          (x) => x.name === 'SectorID' || x.name === '5G_FWA'
        )"
        :key="subIndex"
        dense
        class="custom-bg py-0"
      >
        <v-list-tile>
          <p>
            <v-icon :color="setColor(item.value)">
              {{ setIcon(item.value) }}
            </v-icon>
            <span  v-if="item.name === '5G_FWA'">
            <strong>

              {{
                available.includes(item.value)
                  ? '5G internet service available'
                  : '5G internet service not currently available'
              }}
            </strong>

            </span>
            <span v-else>
              {{ `${item.name}:` }}
              <span class="pl-2">{{ item.value }}</span>
            </span>
          </p>
        </v-list-tile>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: mapSQGetters } = createNamespacedHelpers(`orders/sq`);
export default {
  name: 'Qualification5G',
  data: () => ({
    available: ['true', 'Y', '1'],
    notAvailable: ['false', 'N', '0', ''],
  }),
  methods: {
    setIcon(item) {
      let vm = this;
      if (vm.notAvailable.some((x) => x.toLowerCase() === item.toLowerCase()))
        return 'mdi-close-circle';
      else return 'mdi-check-bold';
    },
    setColor(item) {
      let vm = this;
      if (vm.notAvailable.some((x) => x.toLowerCase() === item.toLowerCase()))
        return 'error';
      else return 'success';
    },
    setSqAddress(item) {
      let vm = this;
      if (vm.sq5gResult.location !== undefined) {
        return `${item.streetNumber} ${item.streetName} ${item.streetType}, ${item.suburb}, ${item.state} ${item.postCode}`;
      } else return '';
    },
  },
  computed: {
    ...mapSQGetters(['sq5gResult']),
    setSqId() {
      let vm = this;
      if (vm.sq5gResult !== null) {
        return vm.sq5gResult.sqid;
      } else return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-bg {
  background-color: #f4f4f7;
}

.custom-border {
  border-radius: 4px;
}

.hide {
  color: #f4f4f7;
}
</style>
